import { useHistory } from "react-router-dom";
export var scrollToElement = function scrollToElement(targetSelector) {
  var element = document.querySelector(targetSelector);

  if (element) {
    var y = element.getBoundingClientRect().top + window.pageYOffset - 150;
    window.scrollTo({
      top: y,
      behavior: "smooth"
    });
  }
};

var useLinkResolver = function useLinkResolver() {
  var history = useHistory();

  var resolveAction = function resolveAction(url) {
    var external = new RegExp("^(http|https)://", "i");
    var internal = new RegExp("^/", "i");
    var anchor = new RegExp("^#", "i");

    if (external.test(url)) {
      return window.open(url, "_blank");
    }

    if (internal.test(url)) {
      return history.push(url);
    }

    if (anchor.test(url)) {
      return scrollToElement(url);
    }

    return;
  };

  return {
    resolveAction: resolveAction,
    scrollToElement: scrollToElement
  };
};

export default useLinkResolver;